import ScAccordion from '@garmin/support-components/src/components/ScAccordion/index.vue';
import TheIntroHero from '../../../../components/the-intro-hero/index.vue';

/**
 * Mixins
 */
import TranslationsMixin from '../../../../mixins/translations';

export default {
  name: 'GenericSubView',
  mixins: [TranslationsMixin],
  components: {
    TheIntroHero,
    ScAccordion,
  },
  props: {
    pageHeading: {
      type: String,
      default: '',
    },
    pageSubHeading: {
      type: String,
      default: '',
    },
  },
};
